import { ComponentType, lazy } from 'react';

const RELOAD_STAMP_KEY = 'lazyChunkReloadedAt';

/**
 * React.lazy + 청크 로드 실패 복구.
 * 배포 직후 옛 index.html을 든 브라우저가 새 해시의 청크를 요청하면 404(ChunkLoadError)가 난다.
 * 그 경우 페이지를 1회 새로고침해 새 index.html을 받게 하고, 1분 안에 또 실패하면(네트워크 문제 등)
 * 그대로 던져 가까운 ErrorBoundary가 처리하게 둔다.
 */
export function lazyWithReload<T extends ComponentType<any>>(
  importer: () => Promise<{ default: T }>,
) {
  return lazy(() =>
    importer().catch((error: unknown) => {
      const last = Number(sessionStorage.getItem(RELOAD_STAMP_KEY) ?? 0);
      if (Date.now() - last > 60_000) {
        sessionStorage.setItem(RELOAD_STAMP_KEY, String(Date.now()));
        window.location.reload();
        //* 새로고침이 끝날 때까지 Suspense 폴백을 유지
        return new Promise<{ default: T }>(() => undefined);
      }
      throw error;
    }),
  );
}
